export default "__VITE_ASSET__0e58c198__"